import { Scene } from 'phaser';
import SceneKeys from '~/consts/SceneKeys';
import TextureKeys from '~/consts/TextureKeys';
import { Card } from '~/Game/Card';
import Ingameui from '~/Game/Ingameui';
import Player from '~/Game/Player';
import UI from './UI';
import CardImage from '~/Game/CardImage';
import { Sizer } from 'phaser3-rex-plugins/templates/ui/ui-components';
import { GlobalConfig } from '~/config/GlobalConfig';
import RoundRectangle from 'phaser3-rex-plugins/plugins/roundrectanglecanvas';
import { HandEvaluationResult, HandEvaluator } from '~/Game/HandEvaluationResult';

class GameManager extends Scene {
    uiScene!:UI
    private cardDeck: Card[] = [];
    public tableCards: Card[] = [];
    public playerCards: Card[] = [];
    public geoffCards: Card[] = [];
    public jimCards: Card[] = [];
    public kateCards: Card[] = [];
    inGameUi!:Ingameui;
    normalTimer; 
    txtPos;
    txtWin;
    handRandWindow;
    emitter;
    cardOpen=0;
    txtPopx20;
    constructor() {
        super(SceneKeys.PokerScene);
    }
    create()
    {
        this.SetGameUI()
    }


    openFirst3Card()
    {
        for(var i=0;i<3;i++)
        {
            this.inGameUi.boardCards[i].foldCard()
            this.cardOpen+=1;
        }
    }

    public rankPlayers(win :boolean): void {
        
        const playerResults = [
            { name: "Player", result: HandEvaluator.evaluateHand(this.playerCards, this.tableCards) },
            { name: "Geoff", result: HandEvaluator.evaluateHand(this.geoffCards, this.tableCards) },
            { name: "Jim", result: HandEvaluator.evaluateHand(this.jimCards, this.tableCards) },
            { name: "Kate", result: HandEvaluator.evaluateHand(this.kateCards, this.tableCards) }
        ];

        console.log("Before Sort :"+playerResults.forEach(playerResult => {
            console.log(`Name: ${playerResult.name}, Result:`, playerResult.result);
        }))
        // console.log("result:", JSON.stringify(playerResults, null, 2));
        playerResults.sort((a, b) => this.compareHands(b.result, a.result));
        
        console.log("After Sort :"+playerResults.forEach(playerResult => {
            console.log(`Name: ${playerResult.name}, Result:`, playerResult.result);
        }))

        playerResults.forEach((player, index) => {
            if(player.name==="Geoff")
            {
                this.inGameUi.geoffCon.getChildren()[2].setText(`Position ${index + 1}:Hand ${player.result.rank}`)
            }
            else if (player.name === "Jim") {
                this.inGameUi.jimCon.getChildren()[2].setText(`Position ${index + 1}:Hand ${player.result.rank}`)
            }
            else if (player.name === "Kate") {
                this.inGameUi.kateCon.getChildren()[2].setText(`Position ${index + 1}:Hand ${player.result.rank}`)
            }

            // console.log(`Position ${index + 1}: ${player.name} with ${player.result.rank}`);
        });
        const playerIndex = playerResults.findIndex(player => player.name === "Player");
        var pos;
        this.cameras.main.shake(GlobalConfig.SHAKE_EFF_Time, GlobalConfig.SHAKE_EFF_INT)
            this.emitter = this.add.particles(this.cameras.main.width/2, (this.cameras.main.height/2)-100, TextureKeys.Flare, {
                frame: ['red', 'yellow', 'green'],
                lifespan: 4000,
                speed: { min: 500, max: 100 },
                scale: { start: 1, end: 0 },
                gravityY: 25,
                blendMode: 'ADD',
                emitting: false
            });
        if(playerIndex===0)
        {
            pos='1st with '+playerResults[playerIndex].result.rank;
            if(win)
            {
                this.uiScene.gameOver(4);
                this.emitter.explode(100);
            }
        }
        else if(playerIndex===1)
        {
            pos='2nd with '+playerResults[playerIndex].result.rank
            if(win)
            {
                this.uiScene.gameOver(0.25);
                this.emitter.explode(100);
            }
        }
        else if(playerIndex===2)
        {
            pos='3rd with '+playerResults[playerIndex].result.rank
            if(win)
                this.uiScene.gameOver(0);

        }
        else
        {
            pos='4th with '+playerResults[playerIndex].result.rank
            this.uiScene.gameOver(0);

        }

        if(!win)
        {
            this.uiScene.gameOver(0);
        }
        this.txtPos.setText("You placed "+pos)
    }

    // Helper function to compare two hands based on hand ranking
    private compareHands(resultA: HandEvaluationResult, resultB: HandEvaluationResult): number {
        const handRanks = [
            HandEvaluator.HandRank.RoyalFlush,
            HandEvaluator.HandRank.StraightFlush,
            HandEvaluator.HandRank.FourOfAKind,
            HandEvaluator.HandRank.FullHouse,
            HandEvaluator.HandRank.Flush,
            HandEvaluator.HandRank.Straight,
            HandEvaluator.HandRank.ThreeOfAKind,
            HandEvaluator.HandRank.TwoPair,
            HandEvaluator.HandRank.OnePair,
            HandEvaluator.HandRank.HighCard
        ];

        // Get index of each hand's rank
        const rankAIndex = handRanks.indexOf(resultA.rank);
        const rankBIndex = handRanks.indexOf(resultB.rank);

        if (rankAIndex !== rankBIndex) {
            return rankBIndex - rankAIndex;
        }
        // woring 1
        // for (let i = 0; i < Math.min(resultA.cards.length, resultB.cards.length); i++) {
        //     const cardRankA = resultA.cards[i].cardRank;
        //     const cardRankB = resultB.cards[i].cardRank;
    
        //     if (cardRankA !== cardRankB) {
        //         return cardRankB - cardRankA; // Higher card ranks should come first
        //     }
        // }

        // working 2

        // var remainingA;
        // var remainingB;
        // if(resultA.rank===HandEvaluator.HandRank.OnePair)
        // {
        //     remainingA = resultA.cards.slice(2,resultA.cards.length);
        //     remainingB = resultB.cards.slice(2,resultB.cards.length);
        //     // console.log("one pair remaining card A : "+remainingA);
        //     // console.log("one pair remaining card B : "+remainingB);
        //     for (let i = 0; i < Math.min(remainingA.length, remainingB.length); i++) {
        //         if (remainingA[i].cardRank !== remainingB[i].cardRank) {
                    
        //             // console.log("one pair selected card A : "+remainingA[i].cardRank+"  selected card B : "+remainingB[i].cardRank);
        //             return remainingA[i].cardRank - remainingB[i].cardRank; // Higher rank comes first
        //         }
        //     }
        //     return 0;
        // }
        // else if(resultA.rank===HandEvaluator.HandRank.TwoPair || resultA.rank===HandEvaluator.HandRank.FourOfAKind)
        // {
        //     remainingA = resultA.cards.slice(4,resultA.cards.length);
        //     remainingB = resultB.cards.slice(4,resultB.cards.length);
        //     // console.log("two pair remaining card A : "+remainingA);
        //     // console.log("two pair remaining card B : "+remainingB);
        //     for (let i = 0; i < Math.min(remainingA.length, remainingB.length); i++) {
        //         if (remainingA[i].cardRank !== remainingB[i].cardRank) {

        //             // console.log("selected card A : "+remainingA[i].cardRank+"  selected card B : "+remainingB[i].cardRank);
        //             return remainingA[i].cardRank - remainingB[i].cardRank; // Higher rank comes first
        //         }
        //     }
        //     return 0;
        // }
        // else if (resultA.rank === HandEvaluator.HandRank.ThreeOfAKind) {
        //     remainingA = resultA.cards.slice(3, resultA.cards.length);
        //     remainingB = resultB.cards.slice(3, resultB.cards.length);
        //     // console.log("three kind remaining card A : " + remainingA);
        //     // console.log("three kind remaining card B : " + remainingB);
        //     for (let i = 0; i < Math.min(remainingA.length, remainingB.length); i++) {
        //         if (remainingA[i].cardRank !== remainingB[i].cardRank) {

        //             // console.log("selected card A : "+remainingA[i].cardRank+"  selected card B : "+remainingB[i].cardRank);
        //             return remainingA[i].cardRank - remainingB[i].cardRank; // Higher rank comes first
        //         }
        //     }
        //     return 0;
        // }

        // else
        {
            for (let i = 0; i < Math.min(resultA.cards.length, resultB.cards.length); i++) {
                if (resultA.cards[i].cardRank !== resultB.cards[i].cardRank) {

                    return resultA.cards[i].cardRank - resultB.cards[i].cardRank; // Higher rank comes first
                }
            }
            return 0;
        }
        // const cardsA = resultA.cards;
        // const cardsB = resultB.cards;
        // for (let i = 0; i < Math.min(cardsA.length, cardsB.length); i++) {
        //     if (cardsA[i].cardRank !== cardsB[i].cardRank) {
        //         return cardsB[i].cardRank - cardsA[i].cardRank; // Higher rank comes first
        //     }
        // }

        // const sortedCardsA = [...resultA.cards].sort((a, b) => b.cardRank - a.cardRank);
        // const sortedCardsB = [...resultB.cards].sort((a, b) => b.cardRank - a.cardRank);

        // // Compare cards one by one
        // for (let i = 0; i < Math.min(sortedCardsA.length, sortedCardsB.length); i++) {
        //     console.log("sort a "+sortedCardsA[i].cardRank +"  "+sortedCardsB[i].cardRank)
        //     if (sortedCardsA[i].cardRank !== sortedCardsB[i].cardRank) {
                
        //         console.log("sort a "+sortedCardsA[i].cardRank +"  "+sortedCardsB[i].cardRank)
        //         return sortedCardsB[i].cardRank - sortedCardsA[i].cardRank; // Higher rank comes first
        //     }
        // }

        return 0;
        // return this.compareSameRankHands(resultA, resultB);
        // return this.compareHighCards(resultA.cards, resultB.cards);
    }


    private compareSameRankHands(resultA: HandEvaluationResult, resultB: HandEvaluationResult): number {
        const rank = resultA.rank;
    
        if (rank === HandEvaluator.HandRank.OnePair || 
            rank === HandEvaluator.HandRank.TwoPair || 
            rank === HandEvaluator.HandRank.ThreeOfAKind || 
            rank === HandEvaluator.HandRank.FourOfAKind) {
            
            // Compare groups of cards (pairs, triples, quads)
            const groupRankA = this.getGroupRank(resultA.cards, rank);
            const groupRankB = this.getGroupRank(resultB.cards, rank);
    
            if (groupRankA !== groupRankB) {
                return groupRankB - groupRankA; // Higher group rank wins
            }
    
            // If the group ranks are the same, compare kickers
            return this.compareKickers(resultA.cards, resultB.cards, groupRankA);
        }
    
        // For hands that don't involve groups (e.g., High Card, Flush), compare all cards directly
        return this.compareHighCards(resultA.cards, resultB.cards);
    }
    
    // Extract the rank of the main group (pair, triple, quad) in a hand
    private getGroupRank(cards: Card[], handRank: string): number {
        const groupSize = handRank === HandEvaluator.HandRank.OnePair ? 2
                        : handRank === HandEvaluator.HandRank.TwoPair ? 2
                        : handRank === HandEvaluator.HandRank.ThreeOfAKind ? 3
                        : handRank === HandEvaluator.HandRank.FourOfAKind ? 4
                        : 0;
    
        const groups = this.getGroups(cards, groupSize);
        if (groups.length > 0) {
            return groups[0][0].cardRank; // Return the rank of the first card in the group
        }
        return 0;
    }
    private getGroups(cards: Card[], groupSize: number): Card[][] {
        // Create a map to group cards by their rank
        const rankMap: Map<number, Card[]> = new Map();
    
        for (const card of cards) {
            if (!rankMap.has(card.cardRank)) {
                rankMap.set(card.cardRank, []);
            }
            rankMap.get(card.cardRank)?.push(card);
        }
    
        // Filter groups by the specified size and sort them by rank descending
        const groups = Array.from(rankMap.values())
            .filter(group => group.length === groupSize)
            .sort((a, b) => b[0].cardRank - a[0].cardRank);
    
        return groups;
    }
    
    // Compare kickers when the group ranks are the same
    private compareKickers(cardsA: Card[], cardsB: Card[], groupRank: number): number {
        // Remove the cards that form the group (pair, triple, etc.)
        const remainingA = cardsA.filter(card => card.cardRank !== groupRank);
        const remainingB = cardsB.filter(card => card.cardRank !== groupRank);
    
        // Sort remaining cards by rank descending
        const sortedA = remainingA.sort((a, b) => b.cardRank - a.cardRank);
        const sortedB = remainingB.sort((a, b) => b.cardRank - a.cardRank);
    
        // Compare the remaining cards as kickers
        for (let i = 0; i < Math.min(sortedA.length, sortedB.length); i++) {
            if (sortedA[i].cardRank !== sortedB[i].cardRank) {
                return sortedB[i].cardRank - sortedA[i].cardRank; // Higher kicker wins
            }
        }
    
        // If all kickers are the same, it's a tie
        return 0;
    }
    
    // Compare high cards in descending order
    private compareHighCards(cardsA: Card[], cardsB: Card[]): number {
        // Sort both hands by rank descending
        const sortedA = [...cardsA].sort((a, b) => b.cardRank - a.cardRank);
        const sortedB = [...cardsB].sort((a, b) => b.cardRank - a.cardRank);
    
        // Compare cards one by one
        for (let i = 0; i < Math.min(sortedA.length, sortedB.length); i++) {
            if (sortedA[i].cardRank !== sortedB[i].cardRank) {
                return sortedB[i].cardRank - sortedA[i].cardRank; // Higher card wins
            }
        }
    
        // If all cards are the same, it's a tie
        return 0;
    }
    // private compareHighCards(cardsA: Card[], cardsB: Card[]): number {
    //     // Sort both hands by rank descending
    //     const sortedA = [...cardsA].sort((a, b) => b.cardRank - a.cardRank);
    //     const sortedB = [...cardsB].sort((a, b) => b.cardRank - a.cardRank);
    //     console.log("sort a "+sortedA)
    //     console.log("sort b "+sortedB)
    //     // Compare cards one by one
    //     for (let i = 0; i < Math.min(sortedA.length, sortedB.length); i++) {
    //         if (sortedA[i].cardRank !== sortedB[i].cardRank) {
    //             return sortedB[i].cardRank - sortedA[i].cardRank; // Higher card wins
    //         }
    //     }
    
    //     // If all cards are the same, it's a tie
    //     return 0;
    // }

    public SetGameUI()
    {

        // console.log("called "+this.cameras.main.width)


        this.inGameUi= new Ingameui(this)
        this.cardDeck=[]
        this.tableCards=[];
        this.playerCards=[];
        this.geoffCards=[]
        this.jimCards=[];
        this.kateCards=[]
        this.createDeck()
        this.distributeCards();
        this.inGameUi.SetupBoard()
        this.uiScene = this.scene.get(SceneKeys.UIScene) as UI;
        this.cardOpen=0;
        // this.openFirst3Card()

        


        this.txtPos = this.add.text(this.cameras.main.width / 2 - 150, 738, "",
            {
                fontSize: '35px',
                fontFamily: GlobalConfig.FONT_FAMILY,
                align: 'center',
                color: "#" + GlobalConfig.FONT_COLOR.toString(16)
            }).setOrigin(1, 0.5)
        this.txtWin = this.add.text(this.cameras.main.width / 2 + 200, 738, "",
            {
                fontSize: '35px',
                fontFamily: GlobalConfig.FONT_FAMILY,
                align: 'center',
                color: "#" + GlobalConfig.FONT_COLOR.toString(16)
            }).setOrigin(0,0.5)

            
        
        this.add.image(this.cameras.main.width-20,20,TextureKeys.Info).setOrigin(1,0).setInteractive().
        on('pointerdown',
            () => {
                this.handRandWindow.setVisible(true)
            });
        const rank=this.add.image(this.cameras.main.width/2,this.cameras.main.height/2,TextureKeys.Ranking)
        const close=this.add.image(rank.x+750,rank.y-280,TextureKeys.CloseRanking).setInteractive().
        on('pointerdown',
            () => {
                this.handRandWindow.setVisible(false)
            });
            
            
        this.handRandWindow=this.add.container(0,0,[rank,close])
        this.handRandWindow.setVisible(false)

        this.txtPopx20 = this.add.text(this.cameras.main.width - 150, 180, "",
            {
                fontSize: '35px',
                fontFamily: GlobalConfig.FONT_FAMILY,
                align: 'center',
                color: "#" + GlobalConfig.FONT_COLOR.toString(16)
            }).setOrigin(1, 0.5)
            // this.showBetPop()
    }

    OpenAiCard()
    {
        this.inGameUi.Ai1Cards.forEach(element => {
            element.foldCard()
        });
        this.inGameUi.Ai2Cards.forEach(element => {
            element.foldCard()
        });
        this.inGameUi.Ai3Cards.forEach(element => {
            element.foldCard()
        });
    }

    public StartGame()
    {
        this.OpenNewBoardCard()
        this.normalTimer=this.time.addEvent({
            delay: 2000,
            callback: this.OpenNewBoardCard,
            callbackScope: this, 
            loop: true 
        });
    }

    ease;
    showBetPop()
    {
        this.txtPopx20.setVisible(true)
    // console.log(this.)
        this.txtPopx20.x=(this.cameras.main.width+200)
        this.ease=this.tweens.add({
            targets: this.txtPopx20,
            x: this.cameras.main.width-50,
            ease: 'Linear',
            duration: 250, 
            onUpdate: (tween, target) => {
                // Log progress during the tween update
                
            },
            onComplete: () => {
                this.time.delayedCall(1000, () => {
                    this.txtPopx20.setVisible(false)
                });
                // console.log('Tween complete');
                // this.NextPos();
            }
        });
    }

    OpenNewBoardCard()
    {
        this.cardOpen+=1;
        if(this.cardOpen>this.tableCards.length)
        {
            this.OpenAiCard()
            this.normalTimer.remove()
            this.uiScene.autoplayBtn.disableInteractive()
            this.uiScene.autoplayBtn.setTexture(TextureKeys.AutoPlayU)
            this.rankPlayers(true)
            // this.time.addEvent({
            //     delay: 2000,
            //     callback: ()=>{
            //         this.rankPlayers()
            //     },
            //     callbackScope: this
            // });
        }
        else
        {
            this.inGameUi.boardCards[this.cardOpen-1].foldCard()
        }
    }

    openRemainigCards()
    {
        console.log('last open '+this.cardOpen)
        if(this.cardOpen==0)
        {
            this.cardOpen=1;
        }
        for(var i=this.cardOpen-1;i<this.tableCards.length;i++)
        {
            console.log('las '+i+"  "+this.inGameUi.boardCards[i])
            this.inGameUi.boardCards[i].foldCard(true)
        }
        this.time.addEvent({
            delay: 2000,
            callback: ()=>{
                this.OpenAiCard()
                this.time.addEvent({
                    delay: 2000,
                    callback: ()=>{
                        this.rankPlayers(false)
                        // this.uiScene.gameOver(0)
                    },
                    callbackScope: this, 
                });
            },
            callbackScope: this, 
        });
    }

    public Fold()
    {
        this.uiScene.setLastWin(0)
        this.normalTimer?.remove()
        this.openRemainigCards()
    }

    private createDeck() {
        for (let suit of Object.values(Card.Suit)) {
            for (let rank of Object.values(Card.Rank)) {
                const imgPath = this.getCardImagePath(suit, rank); 
                const card = new Card(suit, rank, imgPath);
                this.cardDeck.push(card);
            }
        }
        this.shuffleDeck()
    }

    shuffleDeck() {
        let currentIndex = this.cardDeck.length, randomIndex, temporaryValue;
        while (currentIndex !== 0) {
            randomIndex = Math.floor(Math.random() * currentIndex);
            currentIndex -= 1;
            temporaryValue = this.cardDeck[currentIndex];
            this.cardDeck[currentIndex] = this.cardDeck[randomIndex];
            this.cardDeck[randomIndex] = temporaryValue;
        }
    }

    distributeCards()
    {
        this.AssignCard(this.tableCards,5);
        this.AssignCard(this.geoffCards,2);
        this.AssignCard(this.kateCards,2);
        this.AssignCard(this.playerCards,2);
        this.AssignCard(this.jimCards,2);

        // console.log(this.tableCards)
        // console.log(this.geoffCards)
        // console.log(this.kateCards)
        // console.log(this.playerCards)
        // console.log(this.jimCards)
        // console.log(this.cardDeck)

    }

    AssignCard(cards: Card[],size:number)
    {
        for(var i=0;i<size;i++)
        {
            cards.push(this.cardDeck[i])
            this.cardDeck.splice(i,1)
        }
    }

    private getCardImagePath(suit: string, rank: number): string {
        return `${suit.toLowerCase()}_${rank}.png`;
    }
    
}

export default GameManager;
